/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.BoothText = function( boothGraphic, centerX, centerY, textHeight) {
    
    //   getCanvas
    var canvas = document.createElement( "canvas");
    var ctx = canvas.getContext( "2d");
    var texture = null;
    var material = null;
    var geom = null;
    var mesh = null;
    var i = 0;
    var textX = 0;
    var textY = 0;
    var textWidth = 0;
    
//    var overhange = 20;
    var bthW = boothGraphic.maxX - boothGraphic.minX;    //  make mesh bigger to allow a little text
    var bthH = boothGraphic.maxY - boothGraphic.minY;    //   outside of booth
    
    canvas.width = bthW;
    canvas.height = bthH;
    
        //   write text to canvas
    ctx.textBaseline = "bottom";
    
    for( i = 0; i < boothGraphic.text.length; i++) {
        ctx.font = boothGraphic.text[i].fontSize + "px Arial";
        
        textWidth = ctx.measureText( boothGraphic.text[i].text).width;
        
        textX = boothGraphic.text[i].x - boothGraphic.minX;
        textY = boothGraphic.text[i].y - boothGraphic.minY;
        
        ctx.fillStyle = boothGraphic.text[i].fill;
        
        if( boothGraphic.text[i].rotation !== 0) {
            ctx.save();
            ctx.translate( textX, textY);
            ctx.rotate( boothGraphic.text[i].rotation);
            ctx.translate( -textX, -textY);

            ctx.fillText( boothGraphic.text[i].text,
                         textX - 0.5 * textWidth,
                         textY + boothGraphic.text[i].fontSize/2 + 5);
            ctx.restore();
        }
        else {
            ctx.fillText( boothGraphic.text[i].text,
                         textX - 0.5 * textWidth - 5,
                         textY + boothGraphic.text[i].fontSize/2);
        }
    }
    
        //  canvas --> mesh
    texture = new THREE.Texture( canvas);
    texture.needsUpdate = true;
    
    texture.magFilter = THREE.LinearFilter;
    texture.minFilter = THREE.LinearMipMapLinearFilter;
    texture.anisotropy = 1;
    
    material = new THREE.MeshBasicMaterial( {map: texture,
                                            depthWrite: false,
                                            depthTest: false});
    material.map.minFilter = THREE.LinearFilter;
    material.transparent = true;
    
    geom = new THREE.PlaneBufferGeometry( canvas.width, canvas.height);
    
    mesh = new THREE.Mesh( geom, material);
    
    mesh.position.z = textHeight;
    
    return mesh;
};